import type { ChargesConfig } from '../../../domain/types/configs/company/ChargesConfig';

export const chargesConfig: ChargesConfig = {
  chargesType: [
    {
      value: "FLETE",
      label: "FLETE",
      visible: true
    },
    {
      value: "CARGO DE COMBUSTIBLE",
      label: "CARGO DE COMBUSTIBLE",
      visible: true
    },
    {
      value: "CARGOS EN ORIGEN",
      label: "CARGOS EN ORIGEN",
      visible: true
    },
    {
      value: "CARGOS EN DESTINO",
      label: "CARGOS EN DESTINO",
      visible: true
    },
    {
      value: "DMC DE ENTRADA",
      label: "DMC DE ENTRADA",
      visible: true
    },
    {
      label: "DMC DE SALIDA",
      value: "DMC DE SALIDA",
      visible: true
    },
    {
      value: "ACARREO",
      label: "ACARREO",
      visible: true
    },
    {
      value: "ALMACENAJE",
      label: "ALMACENAJE",
      visible: true
    },
    {
      label: "TRANSPORTE DE MATERIAL RADIOACTIVO",
      value: "TRANSPORTE DE MATERIAL RADIOACTIVO",
      visible: true
    },
    {
      value: "SEGURO",
      label: "SEGURO",
      visible: true
    },
    {
      value: "CARGOS DE PICKUP",
      label: "CARGOS DE PICKUP",
      visible: true
    },
    {
      value: "TRÁMITES ADUANALES",
      label: "TRÁMITES ADUANALES",
      visible: true
    },
    {
      label: "OTROS",
      value: "OTROS",
      visible: true
    }
  ],
  showChargesCatalog: true
}; 